/** Grandparent Mode — one tap: larger type, bigger buttons, calmer spacing.
 *  Persisted per device; applies a `grandparent` class on <html> which scales
 *  every rem-based size via CSS in index.css.
 */
import { createContext, useContext, useEffect, useState } from "react";

const GrandparentContext = createContext(null);
const KEY = "ft_grandparent";

export function GrandparentProvider({ children }) {
  const [on, setOn] = useState(() => {
    try {
      return localStorage.getItem(KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    document.documentElement.classList.toggle("grandparent", on);
    try {
      localStorage.setItem(KEY, on ? "1" : "0");
    } catch { /* private mode */ }
  }, [on]);

  return (
    <GrandparentContext.Provider value={{ on, toggle: () => setOn((v) => !v) }}>
      {children}
    </GrandparentContext.Provider>
  );
}

export function useGrandparent() {
  return useContext(GrandparentContext);
}
